export default "/images/vendor/flag-icon-css/flags/4x3/mh.svg?d3854d0ef79845fd219754cb6de94fcd";